import { Box, Typography, Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type SelectionOverviewProps = {
  loading?: boolean;
  selectionOverviewText?: string;
  selectedCount: number;
  color?: 'primary' | 'secondary';
  fullScreen?: boolean;
};

export const SelectionOverview: React.VFC<SelectionOverviewProps> = ({ color = 'secondary', ...props }) => {
  const { classes, cx } = useSelectionOverviewStyles();

  return (
    <Box className={cx(classes.selectionOverviewContainer, {
      [classes.fullScreen]: props.fullScreen,
    })}
    >
      {!props.loading && <Typography color={color}><b>{props.selectedCount}</b> {props.selectionOverviewText || 'selected'}</Typography>}
      {props.loading && <Skeleton width="200px" variant="text" />}
    </Box>
  );
};

const useSelectionOverviewStyles = makeStyles({ name: 'SelectionOverview' })(theme => ({
  selectionOverviewContainer: {
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `inset 0px 1px 0px ${theme.palette.divider}`,
  },
  fullScreen: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),

    }
  }
}));
